import { Grid } from '@mui/material';
import moment from 'moment';

import { FormFieldReadOnlyValue } from '../../../../../common';
import { DATE_DISPLAY_FORMAT } from '../../../../../../constants';

import type { ClientSummarySectionProps } from './types';

export default function ClientSummarySection({ client }: ClientSummarySectionProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <FormFieldReadOnlyValue
          label="Client"
          value={[client?.first_name, client?.last_name].filter(Boolean).join(' ')}
        />
      </Grid>
      <Grid item xs={12} sm={4} md={2}>
        <FormFieldReadOnlyValue
          label="DOB"
          value={
            client?.date_of_birth ? moment(client.date_of_birth).format(DATE_DISPLAY_FORMAT) : ''
          }
        />
      </Grid>
      <Grid item xs={12} sm={4} md={2}>
        <FormFieldReadOnlyValue label="Gender" value={client?.sex ?? ''} />
      </Grid>
      <Grid item xs={12} sm={4} md={2}>
        <FormFieldReadOnlyValue label="Client ID" value={client ? String(client.id) : ''} />
      </Grid>
    </Grid>
  );
}
